// This could probably be abstracted to use getsoft, now that we have arbitrary caching
class Settings {
	constructor(parent) {
		this.parent = parent;
		this.endpoint = 'settings';
		this.data = false;
	}

	async get(key) {
		if (this.data === false)
			await this.retrieve();
		if (this.data.hasOwnProperty(key))
			return this.data[key];
		else
			return false;
	}
	
	async retrieve(key) {
		try {
			this.data = await this.parent.get(this.endpoint);
			// If that one isn't found, return an error.
			// Otherwise return it.
		} catch(e) {
			this.parent.handleExceptions(e);
		};
	}
}


export default Settings;
